<div class="container-fluid py-3" style="width: 450px">
  <div class="d-flex align-items-center justify-content-between mb-4">
    <h3 class="mb-0">Reset Password</h3>
    <img
      src="assets/images/close-icon.svg"
      alt="close-icon"
      (click)="closeDialogRef.close()"
      class="cursor-pointer"
      [attr.aria-hidden]="true" />
  </div>
  <form
    class="mat-form"
    [formGroup]="changePasswordFrom"
    (ngSubmit)="onChangePassword()">
    <div class="row">
      <div class="col-md-12 form-group">
        <app-input-template
          [inputData]="attributeConstant.profile.newPassword"
          [formControlName]="attributeConstant.profile.newPassword.key">
        </app-input-template>
        <app-input-template
          class="d-block mt-2"
          [inputData]="attributeConstant.profile.confirmPassword"
          [formControlName]="attributeConstant.profile.confirmPassword.key">
        </app-input-template>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 text-end">
        <button
          class="btn primary-btn"
          [ngClass]="isSubmitLoading ? 'dsbld' : 'enbld'">
          <img
            *ngIf="isSubmitLoading"
            src="assets/images/button-spinner.svg"
            alt="button-spinner" />Submit
        </button>
      </div>
    </div>
  </form>
</div>
